<template lang='pug'>
v-app
  div(v-if='hasAdmin')
    v-row
      v-col(cols='3')
        v-text-field(v-model='name' label='組織名' hide-details :rules='[value => value ? true : false]' density='comfortable')
      v-col(cols='5')
        v-text-field(v-model='description' label='説明文' hide-details density='comfortable')
      v-col(cols='2')
        v-btn.mt-2(block prepend-icon='mdi-plus' @click='createOrganization' :disabled='!name' color='primary') 新規作成
      v-col(cols='2')
        v-dialog(attach='true' max-width='800')
          template(v-slot:activator='{ props: activatorProps }')
            v-btn.mt-2(block prepend-icon='mdi-table-account' v-bind='activatorProps' color='primary') CSV管理
          template(v-slot:default='{ isActive }')
            v-card.my-3
              v-card-text
                .h5 登録情報ダウンロード
                v-divider.mt-2.mb-4
                .d-flex.align-center
                  v-btn.ms-2(size='small' @click='downloadOrganizations("UTF-8")')
                    v-icon.me-2(icon='mdi-download')
                    | UTF-8形式
                  v-btn.ms-2(size='small' @click='downloadOrganizations("SJIS")')
                    v-icon.me-2(icon='mdi-download')
                    | Shift-JIS形式
                  span.ms-4 ：ユーザー情報一覧をダウンロード
                .d-flex.align-center.my-4
                  v-btn.ms-2(size='small' @click='downloadOrganizationTable("UTF-8")')
                    v-icon.me-2(icon='mdi-download')
                    | UTF-8形式
                  v-btn.ms-2(size='small' @click='downloadOrganizationTable("SJIS")')
                    v-icon.me-2(icon='mdi-download')
                    | Shift-JIS形式
                  span.ms-4 ：組織情報一覧をダウンロード

                .h5.mt-6 ユーザー情報一括変更
                v-divider.mt-2.mb-4
                v-row
                  v-col
                    .d-flex.align-center
                      v-btn.ms-2(size='small' @click='downloadPersonnelChanges("UTF-8")')
                        v-icon.me-2(icon='mdi-download')
                        | UTF-8形式
                      v-btn.ms-2(size='small' @click='downloadPersonnelChanges("SJIS")')
                        v-icon.me-2(icon='mdi-download')
                        | Shift-JIS形式
                      span.ms-4 ：ユーザー情報変更用のデータをダウンロード
                v-row.mb-2
                  v-col.pt-0(cols='12')
                    v-file-input(density='compact' v-model='personnelChangesFile' label='人事異動用のデータ' accept='.csv' hide-details)
                    v-btn.mt-3(@click='uploadPersonnelChanges' :disabled='!personnelChangesFile')
                      v-icon.me-2(icon='mdi-application-import')
                      | インポート開始

                .h5.mt-2 ユーザー一括登録
                v-divider.mt-2.mb-4
                v-row
                  v-col
                    .d-flex.align-center
                      v-btn.ms-2(size='small' @click='downloadRegistrationTemplate("UTF-8")')
                        v-icon.me-2(icon='mdi-download')
                        | UTF-8形式
                      v-btn.ms-2(size='small' @click='downloadRegistrationTemplate("SJIS")')
                        v-icon.me-2(icon='mdi-download')
                        | Shift-JIS形式
                      span.ms-4 ：ユーザー一括登録用データをダウンロード
                v-row
                  v-col.pt-0(cols='12')
                    v-file-input(density='compact' v-model='registrationFile' label='新規ユーザー登録用のデータ' accept='.csv' hide-details)
                    v-btn.mt-3(@click='uploadRegistration' :disabled='!registrationFile')
                      v-icon.me-2(icon='mdi-application-import')
                      | インポート開始
                span.my-2(v-if='uploadErrorMessage' style='color: red') {{ uploadErrorMessage }}

              template(v-slot:actions)
                v-btn.ms-auto(color='grey-darken-2' prepend-icon='mdi-close' text='閉じる', @click='isActive.value = false')

    .mt-1(v-if='!dialog && errorMessage' style='color: red') {{ errorMessage }}

  v-switch.mt-4(v-if='hasAdmin' color='primary' label='組織のドラッグ操作をロックする' true-icon='mdi-lock' false-icon='mdi-lock-open-variant' hide-details inset density='compact' v-model='lockDraggable')

  Draggable.mt-2(v-model='organizations' treeLine @change='updateRelationships' :disableDrag='!hasAdmin || lockDraggable' :disableDrop='!hasAdmin || lockDraggable')
    template(#default='{ node, stat }')
      .py-2
        v-card.w-100(color='#edebfa' variant='elevated')
          v-card-text.py-0.px-2.d-flex.flex-column
            .d-flex.justify-space-between.w-100
              .d-flex.align-center
                OpenIcon(v-if='stat.children.length' :open='stat.open' class='mtl-mr mx-1' @click.native='stat.open = !stat.open')
                .d-flex
                v-icon.me-1(v-if='hasAdmin && !lockDraggable' icon='mdi-drag')
                .d-flex.ms-2 {{ node.name }}
              .d-flex
                v-btn(variant='text' size='small' color='secondary' icon='mdi-eye' :href='`/organizations/${node.id}`')
                v-divider.my-2(vertical color='primary')
                v-btn(v-if='node.admin' variant='text' size='small' color='secondary' icon='mdi-square-edit-outline' @click='showDialog(node.id)')
                v-btn(variant='text' size='small' color='secondary' icon='mdi-information-outline' @click='stat.expand = !stat.expand')
                .d-flex.align-center
                  v-chip.me-2(density='compact' prepend-icon='mdi-account-multiple')
                    | {{ node.users.length }}
                  v-chip(density='compact' prepend-icon='mdi-cube-scan')
                    | {{ node.showcases.length }}
          .d-flex.expand-content
              v-expand-transition
                //- NOTE: v-containerをtransitionさせると動作がかなり重くなるのでv-rowを調整する方針に変更した
                v-row.px-3(v-if='stat.expand')
                  v-col.p-3(cols='12' lg='6')
                    .text-subtitle-2.text-center 所属ユーザー
                    v-divider.mt-1.mb-2
                    v-chip.me-2.mb-2(v-for='user in node.users' density='comfortable' :prepend-icon='user.role === "org_admin" ? "mdi-cog" : user.role === "org_editor" ? "mdi-pencil" : "mdi-eye"')
                      | {{ user.name }}
                  v-col.p-3(cols='12' lg='6')
                    .text-subtitle-2.text-center 所属ショーケース
                    v-divider.mt-1.mb-2
                    v-chip.me-2.mb-2(v-for='showcase in node.showcases' prepend-icon='mdi-open-in-new' :href='`/showcases/${showcase.id}`' target='_blank' density='comfortable')
                      | {{ showcase.name }}

  v-dialog(v-model='dialog', width='90%' max-height='90%' scrollable persistent :attach='true')
    v-card(v-if='selectedOrganizationData' title='組織編集')
      v-divider
      v-card-text
        template(v-if='hasAdmin')
          v-text-field(v-model='selectedOrganizationData.name' label='組織名' hide-details)
        template(v-else)
          h6 組織名
          p {{ selectedOrganizationData.name }}
        v-text-field.mt-3(v-model='selectedOrganizationData.description' label='説明文' hide-details)
        span(v-if='dialog && errorMessage' style='color: red') {{ errorMessage }}

        v-tabs.mt-5(v-model='tab' fixed-tabs)
          v-tab(value='tab-members' text='メンバー')
          v-tab(value='tab-showcases' text='ショーケース')

        v-tabs-window(v-model='tab')
          v-tabs-window-item(value='tab-members')
            v-card
              v-card-text
                h6 メンバー一覧

                v-row.mt-3.border-bottom
                  v-col(cols='2') ID
                  v-col(cols='5') 名前
                  v-col(cols='5') 権限
                template(v-for='user in selectedOrganizationData.users')
                  v-row.border-bottom(v-if='user.role !== "none" || user.ancestor_role !== "none"')
                    v-col(cols='2') {{ user.id }}
                    v-col(cols='5') {{ user.name }}
                    v-col(cols='5') {{ getRoleName(user.role, user.ancestor_role) }}

                v-expansion-panels.mt-5
                  v-expansion-panel
                    v-expansion-panel-title メンバー編集
                    v-expansion-panel-text
                      v-data-table(:headers='headers' :items='selectedOrganizationData.users' item-value='id' density='compact' show-select hide-default-header)
                        template(v-slot:item.data-table-select= '{ item }')
                          v-checkbox(v-if='item.ancestor_role === "none"' v-model='selectedUserIds' :value='item.id' hide-details @update:modelValue='changeAffiliation(item)')
                        template(v-slot:item.roles='{ item, isSelected, select }')
                          p.mt-3(v-if='item.ancestor_role !== "none"') {{ `親組織の${getRoleName(item.ancestor_role)}` }}
                          v-select.my-2(v-else v-model='item.role' :items='abilityList' density='compact' label='権限' hide-details @update:modelValue='changeAbility(item)')

          v-tabs-window-item(value='tab-showcases')
            v-card
              v-card-text
                h6 ショーケース一覧

                v-row.mt-3.border-bottom
                  v-col(cols='2') ID
                  v-col(cols='5') SID
                  v-col(cols='5') 名前
                v-row.border-bottom(v-for='showcase in selectedOrganizationData.showcases')
                  v-col(cols='2') {{ showcase.id }}
                  v-col(cols='5') {{ showcase.sid }}
                  v-col(cols='5') {{ showcase.name }}

                v-expansion-panels.mt-5
                  v-expansion-panel
                    v-expansion-panel-title ショーケース編集
                    v-expansion-panel-text
                      v-data-table(v-model='selectedShowcaseIds' :items='showcases' item-value='id' density='compact' show-select hide-default-header)

      template(v-slot:actions)
        v-btn(v-if='hasAdmin' color='red' prepend-icon='mdi-trash-can' text='削除', @click='deleteOrganization')
        v-btn.ms-auto(prepend-icon='mdi-check' text='OK', @click='closeDialog')
</template>

<script setup>
import axios from 'axios'
import { ref } from 'vue'
import { BaseTree, Draggable, OpenIcon } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

const props = defineProps({
  hasAdmin: {
    type: Boolean
  },
  organizationBaseUrl: {
    type: String,
    required: true
  },
  organizations: {
    type: String,
    required: true
  },
  showcases: {
    type: String,
    required: true
  }
})
const hasAdmin = props.hasAdmin
const organizationBaseUrl = props.organizationBaseUrl
const organizations = ref(JSON.parse(props.organizations))
const showcases = ref(JSON.parse(props.showcases))

const expand = ref(false)

const abilityList = [
  { title: '未所属', value: 'none'},
  { title: '管理者', value: 'org_admin' },
  { title: '編集者', value: 'org_editor' },
  { title: '閲覧者', value: 'org_member' }
]
const description = ref(null)
const dialog = ref(false)
const errorMessage = ref(null)
const headers  = [
  { text: 'ID', value: 'id' },
  { text: '名前', value: 'name' },
  { text: '権限', value: 'roles' }
]
const lockDraggable = ref(true)
const name = ref(null)
const personnelChangesFile = ref(null)
const registrationFile = ref(null)
const selectedOrganizationData = ref(null)
const selectedShowcaseIds = ref([])
const selectedUserIds = ref([])
const tab = ref('tab-members')
const uploadErrorMessage = ref(null)

const changeAbility = (item) => {
  if (item.role === 'none') {
    selectedUserIds.value = selectedUserIds.value.filter(id => id !== item.id)
  } else if (!selectedUserIds.value.includes(item.id)) {
    selectedUserIds.value.push(item.id)
  }
}

const changeAffiliation = (item) => {
  selectedOrganizationData.value.users.forEach(user => {
    const data = selectedUserIds.value.find(id => id === user.id)
    if (data) {
      if (user.role === 'none') {
        user.role = 'org_member'
      }
    } else {
      user.role = 'none'
    }
  })
}

const closeDialog = async () => {
  try {
    const newData = selectedOrganizationData.value
    newData.showcase_ids = selectedShowcaseIds.value
    newData.user_ids = selectedUserIds.value
    const user_roles = selectedOrganizationData.value.users.map(user => {
      return { id: user.id, role: user.role }
    })

    const res = await axios.patch(`${organizationBaseUrl}/${selectedOrganizationData.value.id}`, {
      organization: { ...newData },
      user_roles: user_roles
    })
    organizations.value = res.data.data
    selectedOrganizationData.value = null
    selectedShowcaseIds.value = []
    selectedUserIds.value = []
    errorMessage.value = null
    dialog.value = false
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const createOrganization = async () => {
  try {
    const res = await axios.post(organizationBaseUrl, {
      organization: { name: name.value, description: description.value }
    })
    organizations.value = res.data.data
    errorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const deleteOrganization = async () => {
  const result = confirm('削除しますか？子組織がある場合、子組織は自動的に更に上の組織の子組織になるか、該当組織がない場合は空になります。')
  if (result) {
    try {
      const res = await axios.delete(`${organizationBaseUrl}/${selectedOrganizationData.value.id}`)
      organizations.value = res.data.data
      selectedOrganizationData.value = null
      errorMessage.value = null
      dialog.value = false
      showToast(res.data.message)
    } catch (error) {
      errorMessage.value = error.response?.data?.join(',')
    }
  }
}

const downloadFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${filename}.csv`)
  document.body.appendChild(link)
  link.click()
}

const downloadPersonnelChanges = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_personnel_changes?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'personnel-changes')
}

const downloadOrganizationTable = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_organization_table?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'organization-table')
}

const downloadOrganizations = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_organizations?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'organizations')
}

const downloadRegistrationTemplate = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_registration_template?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'registration-template')
}

const getParams = (nodes, parentId = null, result = []) => {
  nodes.forEach((node, index) => {
    result.push({ id: node.id, parent_id: parentId, order: index })
    if (node.children?.length > 0) {
      getParams(node.children, node.id, result)
    }
  })
  return result
}

const getRoleName = (role, ancestor_role) => {
  if (ancestor_role === 'org_admin') {
    return '親組織の管理者'
  }
  if (ancestor_role === 'org_editor') {
    return '親組織の編集者'
  }
  if (ancestor_role === 'org_member') {
    return '親組織の閲覧者'
  }
  if (role === 'org_admin') {
    return '管理者'
  }
  if (role === 'org_editor') {
    return '編集者'
  }
  if (role === 'org_member') {
    return '閲覧者'
  }
  return '未所属'
}

const showDialog = async (id) => {
  // NOTE: close時にnullにしていても残ることがあるのでここでもnullにしておく
  selectedShowcaseIds.value = []
  selectedUserIds.value = []

  try {
    const res = await axios.get(`${organizationBaseUrl}/${id}.json`)
    selectedOrganizationData.value = res.data
    res.data.showcases.forEach(showcase => selectedShowcaseIds.value.push(showcase.id))
    res.data.users.forEach(user => {
      if (user.role !== 'none') {
        selectedUserIds.value.push(user.id)
      }
    })
    dialog.value = true
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const showToast = (message) => {
  const toastElList = [].slice.call(document.querySelectorAll('.toast'))
  if (toastElList.length === 0) {
    // NOTE: Toastが自動作成されないので、ここで作成している
    const toastDiv = document.createElement('div')
    toastDiv.setAttribute('aria-atomic', 'true')
    toastDiv.setAttribute('aria-live', 'assertive')
    toastDiv.setAttribute('role', 'alert')
    toastDiv.classList.add('toast', 'mb-3', 'align-items-center', 'text-white', 'border-0', 'bg-success', 'fade', 'hide')
    toastDiv.innerHTML =
      `<div class="d-flex"><div class="toast-body">${message}</div><button aria-label="Close" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" type="button"></button></div></div>`
    document.getElementById('flash').appendChild(toastDiv)
    new Toast(toastDiv).show()
  } else {
    toastElList[0].querySelector('.toast-body').innerHTML = message
    new Toast(toastElList[0]).show()
  }
}

const updateRelationships = async () => {
  const newRelationships = getParams(organizations.value)
  try {
    const res = await axios.patch(`${organizationBaseUrl}/update_relationships`, {
      new_relationships: newRelationships
    })
    organizations.value = res.data
    errorMessage.value = null
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const uploadPersonnelChanges = async () => {
  const file = personnelChangesFile.value
  const formData = new FormData()
  formData.append('file', file)

  try {
    const res = await axios.post(`${organizationBaseUrl}/upload_personnel_changes`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    organizations.value = res.data.data
    personnelChangesFile.value = null
    uploadErrorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    uploadErrorMessage.value = error.response?.data
  }
}

const uploadRegistration = async () => {
  const file = registrationFile.value
  const formData = new FormData()
  formData.append('file', file)

  try {
    const res = await axios.post(`${organizationBaseUrl}/upload_registration`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    organizations.value = res.data.data
    registrationFile.value = null
    uploadErrorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    uploadErrorMessage.value = error.response?.data
  }
}
</script>
